
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    dataLayer?: any[];
  }
}

export const trackEvent = (eventName: string, parameters?: Record<string, any>) => {
  if (window.gtag) {
    window.gtag('event', eventName, parameters);
  }
  // Analytics tracked - console.log removed for production
};

export const trackConversion = {
  // Phone call tracking
  phoneCall: (phoneNumber: string) => {
    trackEvent('phone_call', {
      event_category: 'Contact',
      event_label: phoneNumber,
      value: 1
    });
  },

  // Contact form submission
  contactForm: (formType: string = 'contact') => {
    trackEvent('form_submit', {
      event_category: 'Contact',
      event_label: formType,
      value: 1
    });
  },

  // Service interest tracking
  serviceInterest: (serviceName: string, servicePrice?: number) => {
    trackEvent('service_interest', {
      event_category: 'Services',
      event_label: serviceName,
      value: servicePrice || 0
    });
  },

  // Gallery image view
  galleryView: (imageName: string, category?: string) => {
    trackEvent('gallery_view', {
      event_category: 'Engagement',
      event_label: imageName,
      custom_parameter_1: category
    });
  },

  // Price calculator usage
  priceCalculator: (selectedServices: string[], totalPrice: number) => {
    trackEvent('price_calculation', {
      event_category: 'Tools',
      event_label: selectedServices.join(', '),
      value: totalPrice
    });
  },

  // Newsletter signup
  newsletter: (email: string) => {
    trackEvent('newsletter_signup', {
      event_category: 'Marketing',
      event_label: 'Newsletter',
      value: 1
    });
  },

  // Page scroll depth
  scrollDepth: (percentage: number) => {
    if (percentage % 25 === 0) { // Track at 25%, 50%, 75%, 100%
      trackEvent('scroll_depth', {
        event_category: 'Engagement',
        event_label: `${percentage}%`,
        value: percentage
      });
    }
  },

  // Time on page
  timeOnPage: (seconds: number) => {
    trackEvent('time_on_page', {
      event_category: 'Engagement',
      event_label: 'Duration',
      value: seconds
    });
  }
};

// Enhanced ecommerce tracking for services
export const trackServiceView = (serviceName: string, price: number, category: string) => {
  if (window.gtag) {
    window.gtag('event', 'view_item', {
      currency: 'PLN',
      value: price,
      items: [{
        item_id: serviceName.toLowerCase().replace(/\s+/g, '_'),
        item_name: serviceName,
        category: category,
        price: price,
        quantity: 1
      }]
    });
  }
};

export const trackServiceBooking = (serviceName: string, price: number) => {
  if (window.gtag) {
    window.gtag('event', 'purchase', {
      transaction_id: `booking_${Date.now()}`,
      currency: 'PLN',
      value: price,
      items: [{
        item_id: serviceName.toLowerCase().replace(/\s+/g, '_'),
        item_name: serviceName,
        category: 'Detailing Services',
        price: price,
        quantity: 1
      }]
    });
  }
};
